<template>
  <el-tag :type="tagType">{{ ebApplicationStateDescription }}</el-tag>
</template>

<script>
import { mapGetters } from 'vuex';
import { STATE } from '@/enum/EarlyBirdApplicationStates';

// maps a state to a tag type
const TYPE_MAP = {};
TYPE_MAP[STATE.NOT_STARTED] = null;
TYPE_MAP[STATE.IN_PROGRESS] = 'warning';
TYPE_MAP[STATE.QUALIFIED] = 'info';
TYPE_MAP[STATE.DOES_NOT_QUALIFY] = 'danger';
TYPE_MAP[STATE.ENROLLED] = 'success';
TYPE_MAP[STATE.OPT_OUT] = 'danger';

export default {
  computed: {
    ...mapGetters('Client', [
      'ebApplicationState',
      'ebApplicationStateDescription',
    ]),
    tagType() {
      return TYPE_MAP[this.ebApplicationState];
    },
  },
};

</script>
